export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function formatDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function api(path, options = {}) {
  const response = await fetch(`${API}${path}`, { credentials: "include", ...options });
  if (response.status === 401) {
    window.location.href = "/admin/login";
    throw new Error("Session expired");
  }
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(formatDetail(data.detail));
  }
  return response.json();
}
